import { ArrowUpRight } from 'lucide-react'
import { useGetSessionReviewersQuery } from '../services/sessionReviewersApi'
import { Link } from './nav'
import './SessionReviewers.css'

export default function SessionReviewers({ projectId }: { projectId: string }) {
  const query = useGetSessionReviewersQuery(projectId, { pollingInterval: 30000, skipPollingIfUnfocused: true })
  return <section className="session-reviewers" aria-label="Session reviewers">
    <header><h2>Session reviewers</h2><p>Explore observations and search session results.</p></header>
    {query.isLoading && <p>Loading reviewers…</p>}
    {query.isError && <p role="alert">Could not load reviewers. <button onClick={() => query.refetch()}>Retry</button></p>}
    <div className="session-reviewers__cards">
      {query.currentData?.reviewers.map(reviewer => <Link key={reviewer.key} className="session-reviewers__card" to={`/projects/${projectId}/session-reviewers/${reviewer.key}`}>
        <div className="session-reviewers__card-heading"><h3>{reviewer.name}</h3><ArrowUpRight size={18} aria-hidden="true" /></div>
        <p>{reviewer.goal}</p>
        <div className="session-reviewers__card-counts"><span><strong>{reviewer.reviewed_sessions.toLocaleString()}</strong> sessions reviewed</span><span><strong>{reviewer.observations.toLocaleString()}</strong> observations</span></div>
        <span className="session-reviewers__open-bugs"><strong>{reviewer.open_bugs.toLocaleString()}</strong> open bugs</span>
        <span className="session-reviewers__card-status">Automatic review {reviewer.settings.enabled ? 'enabled' : 'disabled'}</span>
      </Link>)}
    </div>
  </section>
}
